import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  buttonErrorVariant: {
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: theme.palette.error.dark,
    },
  },
  subTitle: {
    width: '100%',
  },
  confirmBox: {
    display: 'flex',
    alignItems: 'center',
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 6,
    padding: '6px 12px',
    marginTop: 8,
    gap: 8,
  },
  confirmDot: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    flexShrink: 0,
  },
}))

export default useStyles
